import { jsxs as t, jsx as s } from "react/jsx-runtime";
import { forwardRef as d } from "react";
import { classNames as c } from "../../../Utils/classNames.js";
const f = d(
  (l, o) => {
    const { className: a, errorMessage: e, ...r } = l;
    return /* @__PURE__ */ t("div", { className: "w-full flex flex-col space-y-2", children: [
      /* @__PURE__ */ s(
        "textarea",
        {
          className: c(
            a,
            "border p-2 rounded-lg w-full min-h-[42px]",
            e ? "border-red-500" : "border-slate-200",
            r.disabled ? "bg-slate-100 cursor-not-allowed" : "bg-white"
          ),
          ...r,
          ref: o
        }
      ),
      e ? /* @__PURE__ */ s("p", { className: "text-red-500", children: e }) : null
    ] });
  }
);
export {
  f as TextAreaInput
};
//# sourceMappingURL=TextAreaInput.js.map
